import * as Areas from './AreaConstants';

export function getInitialAreas() {
    return [
        Areas.INITIAL_BAG,
        Areas.INITIAL_CURRENT,
        Areas.INITIAL_USED,
        Areas.INITIAL_TREASURY,
    ];
}